<template>
	<div class="card bg-primary border-0" v-if="birthdays.length > 0">
		<div class="card-body">
			<div class="d-flex">
				<div>
					<div class="icon text-white">
						<i class="bi bi-cake2"></i>
					</div>
				</div>
				<div class="ps-4 vstack gap-1">
					<router-link :to="{ name: 'company.leader.customer.index', query: { birthdate: 0 } }" class="h4 text-white lh-xs stretched-link">{{ (birthdays.length == 1) ? `1 cliente cumple años hoy` : `${birthdays.length} clientes cumplen años hoy` }}</router-link>
					<span class="text-sm text-white opacity-8 lh-sm">{{ names }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { ref, computed, onMounted } from 'vue';
	import _ from 'lodash';
	import CompanyLeaderCustomerRepository from '@/repositories/modules/Company/Leader/Customer';

	export default {
		setup() {
			const birthdays = ref([]);

			const names = computed(() => {
				let max = 5,
					data = _.map(_.take(birthdays.value, max), 'name');

				if(data.length == 1) return data[0];
				else if(birthdays.value.length > max) return `${_.join(data, ', ')} y más`;
				else if(birthdays.value.length <= max) return `${_.join(_.initial(data), ', ')} y ${_.last(data)}`;
				else return ``;
			});

			onMounted(() => {
				CompanyLeaderCustomerRepository.birthdays().then((response) => {
					birthdays.value = response.data;
				});
			});

			return { birthdays, names };
		}
	}
</script>